// ─────────────────────────────────────────────────────────────────────────────
// Dipendenze globali
// ─────────────────────────────────────────────────────────────────────────────
import {initFaceSlider, initSliderGeo} from "./modules/sliders";

global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

import 'swiper/swiper-bundle.css';

import Headroom from "headroom.js";

import Lenis from 'lenis'

window.$ = window.jQuery = $;


// ─────────────────────────────────────────────────────────────────────────────
// Moduli feature — la logica vive in ./modules/*
// ─────────────────────────────────────────────────────────────────────────────
import {initMarquee} from './modules/marquee.js';
import {initAboutHorizontalScroll} from './modules/about.js';
import {initHorizontalScroll} from './modules/horizontal-scroll.js';
import {
    initWorkIntroAnimation, initWorkBlockAnimations, initWorkDynamicContentAnimations, initMasonryGallery,
} from './modules/work.js';
import {initInformaAnimation} from './modules/informa.js';
import {initLabAdventures} from './modules/lab.js';
import {initHomeVideo} from './modules/home-video.js';
import {initHomeTagline} from './modules/home-tagline.js';
import {initGeoCostellazione, initGeoUniverso,} from './modules/geo.js';
import {initDynamicPageNav} from './modules/page-nav.js';
import {initMenuLetterEffect, initMenuCursor, initNavigationMenu} from './modules/menu.js';
import {initEnterRowAnimation, initServiceDigitalAnimation} from './modules/works-home.js';
import {initMegamenu, destroyMegamenu} from './modules/megamenu.js';
import {scrollTo} from './modules/utils';
import {
    initPanelPin, initChildHeroTitles, initAwardsVenues, initAnimationTitles, initAnimationParagraphs, initProgressBar,
    gsapTextsAnimation,
} from './modules/animations.js';

document.addEventListener('DOMContentLoaded', () => {


    const lenis = new Lenis({
        autoRaf: true, smooth: true, lerp: 0.1,
    });
    window.lenis = lenis; // accessibile globalmente (es. initLabAdventures)

    // To-top button — compare allo scroll verso l'alto, scompare allo scroll verso il basso
    const toTopBtn = document.getElementById('to-top');
    if (toTopBtn) {
        const footer = document.querySelector('footer');
        gsap.set(toTopBtn, {autoAlpha: 0, y: 10});
        let lastScrollY = 0;
        lenis.on('scroll', function ({scroll}) {
            const delta = scroll - lastScrollY;
            lastScrollY = scroll;
            let footerVisible = false;

            if (footer) {
                const footerRect = footer.getBoundingClientRect();
                const viewportCenter = window.innerHeight / 2;

                footerVisible =
                    footerRect.top <= viewportCenter &&
                    footerRect.bottom >= viewportCenter;
            }

            if (footerVisible) {
                gsap.to(toTopBtn, {
                    autoAlpha: 0,
                    y: 10,
                    duration: 0.08,
                    ease: 'power2.in',
                    overwrite: true
                });
                return;
            }

            if (scroll < 120 || delta > 2) {
                gsap.to(toTopBtn, {
                    autoAlpha: 0,
                    y: 10,
                    duration: 0.08,
                    ease: 'power2.in',
                    overwrite: true
                });
            } else if (delta < -2) {
                gsap.to(toTopBtn, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.15,
                    ease: 'power2.out',
                    overwrite: true
                });
            }
        });
        toTopBtn.addEventListener('click', function (e) {
            e.preventDefault();
            lenis.scrollTo(0, {
                duration: 1.4,
                easing: function (t) {
                    return 1 - Math.pow(1 - t, 4);
                }
            });
        });
    }

    // Readabler trigger — nascondi quando il footer entra in viewport (come il to-top)
    {
        const footer = document.querySelector('footer');
        let readablerBtn = null;
        const resolveBtn = () => {
            if (!readablerBtn) {
                readablerBtn = document.getElementById('mdp-readabler-trigger-button');
            }
            return readablerBtn;
        };
        lenis.on('scroll', function () {
            const btn = resolveBtn();
            if (!btn || !footer) return;
            const footerRect = footer.getBoundingClientRect();
            const viewportCenter = window.innerHeight / 2;
            const footerVisible = footerRect.top <= viewportCenter && footerRect.bottom >= viewportCenter;
            btn.classList.toggle('is-hidden-by-footer', footerVisible);
        });
    }

    // Il loop rAF lo gestisce già Lenis con autoRaf: true; un secondo loop manuale
    // raddoppiava il lavoro a ogni frame e saturava la CPU.
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.lagSmoothing(0);

    // ── Headroom (header) + freeze su pagine con horizontal scroll ────────────
    const activeHeadrooms = [];
    if ($('.headroom').length > 0) {
        const headroomEl = document.querySelector('header');
        const headroom = new Headroom(headroomEl, {offset: 100});
        headroom.init();
        activeHeadrooms.push(headroom);
    }

    if ((document.querySelector('.js-h-outer') || document.querySelector('.lab-full'))) {
        document.body.classList.add('has-hscroll');
        activeHeadrooms.forEach((hr) => hr.freeze());
    }

    // ── Megamenu desktop ──────────────────────────────────────────────────────
    if ($(window).width() >= 992) {
        initMegamenu();
    }

    $(window).on('resize', function () {
        if ($(this).width() <= 992) {
            destroyMegamenu();
        } else {
            initMegamenu();
        }
    });

    initSliderGeo();
    initFaceSlider();


    // ── Handlers globali ──────────────────────────────────────────────────────
    $(document).on('click', '.fixed-scroll-btn a', function (e) {
        e.preventDefault();
        scrollTo($(this).attr('href'));
    });

    const footerInfoCollapse = document.getElementById('footer-info-collapse');
    if (footerInfoCollapse) {
        footerInfoCollapse.addEventListener('shown.bs.collapse', () => {
            lenis.stop();
            footerInfoCollapse.scrollIntoView({behavior: 'smooth', block: 'end'});
            setTimeout(() => lenis.start(), 800);
        });
    }

    if ($('.informa-pagination').length > 0 && window.location.search.substr(1)) {
        scrollTo('#informa-main');
    }

    if ($('#performanceFaqAccordion').length > 0 || $("#digitalFaqAccordion").length > 0 || $("#geoFaqAccordion").length > 0 || $("#webFaqAccordion").length > 0 || $("#mobileAdvAccordion").length > 0){
        $('.accordion-collapse').on('shown.bs.collapse', function (e) {
            let $panel = $(this).closest('.accordion-item');
            lenis.scrollTo($panel.offset().top - 200, { duration: 0.8 });
        });
    }

    initAboutHorizontalScroll(lenis);
    initHorizontalScroll({
        lenis,
        // about.js e lab.js si occupano del proprio outer con plan dedicato
        skipIf: () => !!document.querySelector('.about-timeline.js-h-panel') || !!document.querySelector('.lab-full'),
    });
    initMarquee();
    initWorkIntroAnimation();
    initWorkBlockAnimations();
    initWorkDynamicContentAnimations();
    initMasonryGallery();
    initInformaAnimation();
    initLabAdventures();
    initHomeVideo();
    // initSliderWorksHome();
    initEnterRowAnimation();
    initServiceDigitalAnimation();
    initMenuLetterEffect();
    initMenuCursor();
    initNavigationMenu(activeHeadrooms);
    initDynamicPageNav();
    initGeoUniverso();
    initGeoCostellazione();

    initProgressBar();
    initPanelPin();
    initChildHeroTitles();
    initAwardsVenues();

    // Le funzioni qui sotto usano GSAP SplitText: modificano il DOM dei testi
    // spezzandoli in <span> per parola/riga. Se il frontend editor TinyMCE è attivo
    // (l'utente è un admin backend), questo rompe il contenuto al salvataggio perché
    // TinyMCE vedrebbe gli span di SplitText invece del testo originale.
    // La presenza di [data-editable] indica che il plugin fronteditor è attivo.
    if (!document.querySelector('[data-editable]')) {
        initAnimationTitles();
        initAnimationParagraphs();
        gsapTextsAnimation();
    }
});
